import { render } from "./POIpageView.vue?vue&type=template&id=57387353"
import script from "./POIpageView.vue?vue&type=script&lang=js"
export * from "./POIpageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__